export const COLUMNS = 2;
export const optionsTree = (items, subKey, itemRender, exclude, level = 0) => {
    return items.reduce((prev, item) => {
        if (exclude && exclude(item, level))
            return prev;
        prev.push(itemRender(item, '-'.repeat(level * 2)));
        const subTree = item[subKey] || [];
        if (subTree.length > 0)
            return prev.concat(optionsTree(subTree, subKey, itemRender, exclude, level + 1));
        return prev;
    }, []);
};
export const countSubTrees = (parent, subKey) => (parent[subKey] || []).reduce((prev, item) => {
    if (item[subKey])
        return prev + countSubTrees(item, subKey);
    return prev;
}, 1);
export const timeQuery = (url, date) => url && `${url}?t=${date.getTime()}`;
import natsort from 'natsort';
export const narutalSort = (array, // tslint:disable-line:no-any
key, desc = false) => array.sort((a, b) => natsort({ desc })(key && a[key], key && b[key]));
export const objectValues = (object) => {
    const keys = Object.keys(object);
    let values = []; // tslint:disable-line:no-any
    for (let i = 0, length = keys.length; i < length; i++) {
        values.push(object[keys[i]]);
    }
    return values;
};
export const mapValues = (object, iteratee) => {
    const keys = Object.keys(object);
    for (let i = 0, length = keys.length; i < length; i++) {
        object[keys[i]] = iteratee(object[keys[i]]);
    }
    return object;
};
const isObject = item => item && typeof item === 'object' && !Array.isArray(item);
export const mergeDeep = (target, ...sources) => {
    if (!sources.length)
        return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDeep(target, ...sources);
};
export const round = (n, decimals = 2) => Number(Math.round(Number(n + 'e' + decimals)) + 'e-' + decimals);
/*
  método para filtar las horas deshabilitadas en un IDay.hours ya que se puede dar el caso que alguna se haya eliminado
  en el servicio. Las que no estén en horasIda se eliminan
*/
export const filterHours = (horasIda, hoursSelected) => {
    const result = hoursSelected === null || hoursSelected === void 0 ? void 0 : hoursSelected.reduce((previous, hora) => {
        if (horasIda.find((horaIda) => horaIda.hours === hora.hours && horaIda.minutes === hora.minutes)) {
            previous.push(hora);
        }
        return previous;
    }, []);
    return result;
};
// devuelvo las horas habilitadas que tiene un day
export const filterHoursFromDay = (hours, disabledDays, day) => {
    const disabledDay = getDayDisabled(disabledDays, day);
    if (disabledDay) {
        return hours.reduce((previous, current, index, arra) => {
            if (!disabledDay.hours.find(hour => hour.hours === current.hours && hour.minutes === current.minutes)) {
                previous.push(current);
            }
            return previous;
        }, []);
    }
    return hours;
};
// devuelve disabledDay si está day en disabledDays
const getDayDisabled = (disabledDays, day) => {
    if (!disabledDays) {
        return null;
    }
    return disabledDays
        .find(disableDay => disableDay.year === day.getFullYear() &&
        disableDay.month === day.getMonth() &&
        disableDay.day === day.getDate());
};
// devuelve true si está to_do el día deshablitado
export const checkDisabledDay = (hours, disabledDays, day) => {
    if (!disabledDays) {
        return false;
    }
    const dayDisabled = getDayDisabled(disabledDays, day);
    // to_do el día está deshabilitado si dayDisabled no tiene hours, o si tiene
    // hours y están todas las hours del servicio
    if (!dayDisabled) {
        return false;
    }
    let hoursdisabled = 0;
    for (const hour of hours) {
        if (dayDisabled.hours.find(_hour => _hour.hours === hour.hours && _hour.minutes === hour.minutes)) {
            hoursdisabled++;
        }
    }
    return hoursdisabled === hours.length;
};
export const twoDigits = (value) => {
    if (value > 9) {
        return String(value);
    }
    return `0${value}`;
};
export const lengths = {
    stretch: 16,
    packet: 17,
    collaboratorStretch: 18,
    collaboratorPacket: 19,
    cart: 20,
    extra: 12
};
export const generateTicketNumber = (qrTicket, typeTicket) => {
    console.log('generateTicketNumber - typeTicket: ', typeTicket);
    const length = lengths[typeTicket];
    if (!length) {
        throw new Error('typeTicket no valido');
    }
    // const qrTicket: string = this.tempSaleTicket.qrTicket
    // console.log('qrTicket', qrTicket)
    const part2 = randomString(length - 6, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ');
    return qrTicket.concat(part2);
};
export const randomString = (length, chars) => {
    let _chars = chars;
    if (!chars) {
        _chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    }
    let result = '';
    for (let i = length; i > 0; --i)
        result += _chars[Math.floor(Math.random() * _chars.length)];
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Utils.ts
// module id = 18
// module chunks = 0